import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import Image from '@nubank/www-latam-commons/components/Image/Image';
import { smoothScroll as handleLinkClick } from 'utils/domUtils';

function SectionStraightforward({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Box
      tag="section"
      paddingVertical={{ xs: '12x', md: '20x', lg: '24x' }}
      paddingHorizontal={{ xs: '4x', md: '8x', lg: '12x' }}
    >
      <Grid
        row
        alignItems="center"
        justify={{ xs: 'center', xl: 'space-around' }}
      >
        <Grid col={{ xs: 12, sm: 8, lg: 5 }}>
          <Image
            loading="lazy"
            srcSet={{
              xs: {
                '1x': 'phone-and-card/phone-and-card@xs-1x.jpg',
                '2x': 'phone-and-card/phone-and-card@xs-2x.jpg',
              },
              md: {
                '1x': 'phone-and-card/phone-and-card@sm-1x.jpg',
                '2x': 'phone-and-card/phone-and-card@sm-2x.jpg',
              },
              lg: {
                '1x': 'phone-and-card/phone-and-card@md-1x.jpg',
                '2x': 'phone-and-card/phone-and-card@md-2x.jpg',
              },
            }}
            altIntlKey="PIX.STRAIGHTFORWARD.IMAGE_ALT"
          />
        </Grid>
        <Grid col={{ xs: 12, lg: 5, xl: 4 }}>
          <Box marginTop={{ xs: '6x', md: '20x', lg: '0x' }}>
            <Typography
              variant="title"
              intlKey={`cms.pixPage.pixCardsArea[${index}].title`}
              gutterBottom={1.5}
            />

            <Typography
              variant="subtitle"
              intlKey={`cms.pixPage.pixCardsArea[${index}].description`}
              gutterBottom={1.5}
            />

            <Link
              onClick={handleLinkClick}
              href={formatMessage({ id: `cms.pixPage.pixCardsArea[${index}].ctaLink` })}
              variant="action"
              iconProps={{ name: 'arrow-up' }}
              intlKey={`cms.pixPage.pixCardsArea[${index}].ctaText`}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

SectionStraightforward.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionStraightforward);
